export default __webpack_public_path__ + "static/media/farm-FRACTION-MIVA.0527e098.svg";